export default {
  data() {
    return {
      userProfile: {},
    };
  },
  methods: {
    async getProfile() {
      try {
        const { data } = await this.$http.post(
          'application.get-profile',
        );
        this.userProfile = data;
      } catch (e) {
        this.userProfile = {};
      }
    },
    getInitialsName(userName = '') {
      const arrayUserName = userName.split(' ');
      const initials = arrayUserName[0].charAt(0);
      if (arrayUserName.length <= 1) {
        return initials;
      }
      return initials + arrayUserName[arrayUserName.length - 1].charAt(0);
    },
    getAvatar() {
      const { image, name } = this.userProfile;
      if (!image) {
        return {
          initials: this.getInitialsName(name),
        };
      }
      return {
        src: `${process.env.VUE_APP_S3_IMG_URL}${image}`,
        name,
      };
    },
  },
};
